import * as api from '../api';
import { formatNumber, recalculate, roundTwoDecimals } from "../functions";
import {getCustomerGuid} from "../customer";

if ($('body').hasClass('in-predplatne-vyber-nahradniho-produktu')) {


	var render = function (products) {

		var selectProductTable = '';


		products.forEach(function (product) {
			selectProductTable += `<table>
				<thead>
			                                 <tr>
			                                    <th class="tal">Nedostupný produkt</th>
			                                    <th class="tac">
			                                       Množství
			                                    </th>
			                                    
			                                    <th class="tac mobile-hide">
			                                       Sleva
			                                    </th>
			                                    <th class="tac mobile-hide">
			                                       Cena za kus
			                                    </th>
			                                    <th class="tac">
			                                       Součet
			                                    </th>
			                                   
			                                 </tr>
			                              </thead>
				<tr class="single-merchandise">
			                                    <td class="single-merchandise-info row">
			                                       <div class="single-merchandise-foto large-2 medium-3 small-0 columns left">
			                                          <a href="${product.url}" title="${product.name}">
			                                          <img src="https://cdn.myshoptet.com/usr/www.healthfactory.cz/user/shop/related/${product.main_image}">
			                                          </a>
			                                       </div>
			                                       <div class="single-merchandise-text-info large-10 medium-9 small-12 columns">
			                                          <span class="text-wrapper" data-testid="cartProductName">
			                                             <a href="${product.url}" class="main-link">${product.name}</a>
			                                          </span>
			                                       </div>
			                                       <div class="clear">&nbsp;</div>
			                                    </td>
			                                   
			                                    <td class="tac">
			                                          ${product.quantity} Ks
			                                    </td>
			                                    <td class="tac">
			                                          ${product.discount} %
			                                    </td>
			                                    <td class="tac mobile-hide" data-testid="cartItemPrice">
			                                       ${formatNumber(product.price)} Kč
			                                    </td>
			                                    <td class="tac">
			                                       <strong class="nowrap" data-testid="cartPrice">${formatNumber(product.quantity*product.price)} Kč/obj</strong>
			                                    </td>
			                                    
			                                   
			                                 </tr>
				</table>`;

			 var alternativeRows = '';

			 product.relatedProducts.forEach(function (item) {
			 alternativeRows += `<tr class="single-merchandise">
			                                    <td class="single-merchandise-info row">
			                                       <div class="single-merchandise-foto large-2 medium-3 small-0 columns left">
			                                          <a href="${item.url}" title="${item.name}">
			                                          <img src="https://cdn.myshoptet.com/usr/www.healthfactory.cz/user/shop/related/${item.main_image}">
			                                          </a>
			                                       </div>
			                                       <div class="single-merchandise-text-info large-10 medium-9 small-12 columns">
			                                          <span class="text-wrapper" data-testid="cartProductName">
			                                             <a href="${item.url}" class="main-link">${item.name}</a>
			                                          </span>
			                                       </div>
			                                       <div class="clear">&nbsp;</div>
			                                    </td>
			                                   
			                                    <td class="tac">
			                                          ${item.quantity} Ks
			                                    </td>
			                                    <td class="tac">
			                                          ${item.discount} %
			                                    </td>
			                                    <td class="tac mobile-hide" data-testid="cartItemPrice">
			                                       ${formatNumber(item.price)} Kč
			                                    </td>
			                                    <td class="tac">
			                                       <strong class="nowrap" data-testid="cartPrice">${formatNumber(item.quantity*item.price)} Kč/obj</strong>
			                                    </td>
			                                    
			                                   <td style="text-align: center"><label><input type="radio" name="replace[]" data-product="${product.id}" value="${item.id}" required /> Zvolit</label></td>
			                                    
			                                 </tr>
			                                 `;
			 });

			 selectProductTable += `<table style="margin-bottom: 40px">
			                              <colgroup>
			                                 <col style="width: 50%">
			                                 <col class="mobile-hide" style="width: 9%">
			                                 <col style="width: 7%">
			                                 <col class="mobile-hide" style="width: 12%">
			                                 <col style="width: 10%">
			                                 <col style="width: 10%">
			                                 
			                                
			                              </colgroup>
			                              <thead>
			                                 <tr>
			                                    <th class="tal">Náhradní produkt</th>
			                                    <th class="tac">
			                                       Množství
			                                    </th>
			                                    
			                                    <th class="tac mobile-hide">
			                                       Sleva
			                                    </th>
			                                    <th class="tac mobile-hide">
			                                       Cena za kus
			                                    </th>
			                                    <th class="tac">
			                                       Součet
			                                    </th>
			                                    
			                                    <th>Nahradit?</th>
			                                   
			                                 </tr>
			                              </thead>
			                              <tbody>
			                                ${alternativeRows}
														
			                              </tbody>
			                           </table>`
		})

		var html = `<div id="cart-wrapper">
	<div id="cart">
		<p>Níže uvedené produkty nemáme momentálně dostupné. Můžete si zvolit náhradní produkt.</p>
			<form action="" method="post" id="sub-replace-product">
				
				
				${selectProductTable}
				
			    
			    
			    
			    <!--- NECO ---->  
			    
			                      
			  
		                
		      <table id="additional-stuff-in-cart" class="cart-additional-benefits">
                              <tbody>
                              
                              <tr>
                                 <td class="benefit-name">
                                 <strong>Chcete produkty nahradit trvale?: </strong>
                                 <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</span>
                              
                                 </td>
                                 <td class="benefit-value">
                                    <select class="cart-additional-coupon" id="type_replace" required="required">
                                       <option value="">--- Zvolte možnost ---</option>
                                       <option value="1">Ano, chci trvale nahradit</option>
                                       <option value="0">Ne, nahradit jen pro aktuální objednávku</option>
                                    </select>
                                 </td>
                              </tr>
                             
                              </tbody>
                           </table>     
                           
                           <div class="sub-footer">
                          
                           <button type="submit" class="btn">Nahradit produkty</button>
                           </div>                
		   </form>
	   </div>
   </div>`;

		if(localStorage.getItem('replace8')) {
			html = `<div id="cart-wrapper"><p>Děkujeme. Všechny vámi zvolené produkty byly nahrazeny. </p></div>`
		}

		return html;

	}


	showSpinner();



	api.getData('get-replace-products', {guid: getCustomerGuid(), hash: new URLSearchParams(new URL(window.location.href).search).get('hash')})
		.done(function (data) {
			$('#content-in article div').html(render(data));
			hideSpinner();
		})


	$(document).on('submit', '#sub-replace-product', function (e) {
		e.preventDefault();
		showSpinner();


		var update = {'products': {}, 'type_replace': null}

		$(this).find('input:checked').each(function () {
			update['products'][$(this).data('product')] = $(this).val();
		})

		update['type_replace'] = $('#type_replace').val();
		console.log(update);

		api.postData('update-replace-products', update,{guid: getCustomerGuid(), hash: new URLSearchParams(new URL(window.location.href).search).get('hash')})
			.done(function (data) {
				localStorage.setItem('replace8', 'true');
				window.location.reload()
				//hideSpinner();
			})

		setTimeout(function() {
			//localStorage.setItem('replace8', 'true');
			//window.location.reload()
		}, 320);
	})

}


